export default "__VITE_ASSET__ES3jAz1O__"